import { Component, computed, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { DB_PHASES } from '../../../api/app-types/phase.app';
import { TranslocoPipe } from '@jsverse/transloco';
import { TENANT_FEATURES } from '../../services/tenant-feature.service';

@Component({
	selector: 'lvr-assignment-links',
	templateUrl: './assignment-links.html',
	styleUrl: './assignment-links.scss',
	imports: [RouterLink, MatIcon, TranslocoPipe],
})
export class AssignmentLinks {
	private readonly tenantFeatures = inject(TENANT_FEATURES);
	public readonly clientId = input.required<number | string>();
	public readonly assignmentId = input.required<number | string>();
	public readonly reportId = input<number | string | undefined>(undefined);
	public readonly redirectUrl = input<string | undefined>(undefined);
	public readonly isServiceOfficeStatementSubmitView = input<boolean>(false);
	public readonly isAdditionalAssignmentView = input<boolean>(false);
	public readonly targetPhase = input<number | string>();
	public readonly PHASE4 = DB_PHASES.P4;
	public readonly isPhase4Target = computed(() => String(this.targetPhase()) === String(this.PHASE4));
	public readonly showAdditionalAssignmentLink = computed(
		() => !this.isAdditionalAssignmentView() || this.tenantFeatures.additionalAssignmentEnabled(),
	);
}
